import React, { useEffect, useState } from 'react';
import './ActivityCompletionNotice.scss';

const ActivityCompletionNotice = ({
  title = 'Activity completed',
  message = "Nice work. You've completed this activity.",
  className = '',
  duration = 4500,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
    const timeout = setTimeout(() => {
      setVisible(false);
    }, duration);

    return () => clearTimeout(timeout);
  }, [duration, title, message]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className={`activity-completion-notice ${className}`.trim()}
      role='status'
      aria-live='polite'
    >
      <div className='activity-completion-icon' aria-hidden='true'>
        <svg viewBox='0 0 20 20' fill='none'>
          <path
            d='M5 10.5L8.5 14L15 7.5'
            stroke='currentColor'
            strokeWidth='2.2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>
      <div className='activity-completion-copy'>
        <p className='activity-completion-title'>{title}</p>
        <p className='activity-completion-message'>{message}</p>
      </div>
      <button
        type='button'
        className='activity-completion-close'
        onClick={() => setVisible(false)}
        aria-label='Dismiss activity completed message'
      >
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>
  );
};

export default ActivityCompletionNotice;
